import { parseAsStringLiteral, useQueryState } from "nuqs";

export const CONSUMPTION_CHART_METRIC = {
	TOTAL: "total",
	RATIO: "ratio",
} as const;

export type ConsumptionChartMetric =
	(typeof CONSUMPTION_CHART_METRIC)[keyof typeof CONSUMPTION_CHART_METRIC];

const CHART_METRICS = Object.values(CONSUMPTION_CHART_METRIC);

export const useConsumptionChartMetric = () =>
	useQueryState(
		"metric",
		parseAsStringLiteral(CHART_METRICS).withDefault(
			CONSUMPTION_CHART_METRIC.TOTAL,
		),
	);
